/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import {
    Label,
    Icon,
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { useCurrentOrders } from '../Orders/OrdersCurrent/useCurrentOrders'

const OrderCount = () => {
    const { orders } = useCurrentOrders()

    return (
      <div css={css`
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center;
          padding: .6em;
          position: relative;
      `}>
          {orders && orders.length > 0 ? (
            <Link as="div" css={css` position: relative;
                padding: 5px;
                cursor: pointer;`} to="/orders/current">
                <Icon name="shipping fast" style={{color: 'white'}}/>
                <Label color="red" floating circular size="mini">
                    {orders.length}
                </Label>
            </Link>
          ) : (
            <div css={css` position: relative;
                padding: 5px; `}>
                <Icon name="shipping fast" style={{color: 'white'}} disabled/>
            </div>
          )}
      </div>
    )
}

export default OrderCount
